import React, { useState, useEffect } from 'react';
import { fetchCertificationDetails,getCertificationCount, postapprovaldetails } from '../../service/certificationAPI';
import CertificateConfirmationPopup from '../certificationPopup/ConfirmationPopup';
import { encryptStorage } from '../../constant';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import { getS3 } from "../../utils/Download";
 

const FinanceManagement = () => {
    const [certificates, setCertificates] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filters, setFilters] = useState({
        certificationName: "",
        provider: "",
        costFrom: "",
        costTo: "",
        status: ""
    });
    const [selectedCertificate, setSelectedCertificate] = useState(null);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [newStatus, setNewStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [totalRecords, setTotalRecords] = useState(0);
    const [numberOfRecords, setNumberOfRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [sortColumn, setSortColumn] = useState("req_id");
    const [sortOrder, setSortOrder] = useState(-1);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentnumberofRecords, setCurrentnumberofRecords] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [filtersVersion, setFiltersVersion] = useState(0); // Track filter updates
    const [s3Link, sets3Link] = useState("")

    const showLoadMore = certificates?.length >= 10;
    const empId = encryptStorage.getItem('employeeId')

    useEffect(() => {
        if (empId) {
            fetchCertificationCount();
        }
    }, [empId]);


    useEffect(() => {
        fetchCertifications();
    }, [currentnumberofRecords, searchTerm, sortColumn, sortOrder, filtersVersion]);

    const breadCrumnData = [
        { title: 'Dashboard', path: '/overview', isActive: true },
        { title: 'How Do I', path: '/overview', isActive: true },
        { title: 'Certifications', path: '/finance-management', isActive: false },
    ];

    const fetchCertifications = async () => {
        setIsLoading(true);
        try {
            const groupId = encryptStorage.getItem('groupid');
            if (!groupId) {
                throw new Error("Missing required parameters: group_id or domain");
            }
            const params = {
                group_id: 1,
                current_number_of_records: currentnumberofRecords,
                page_size: pageSize,
                search_term: searchTerm,
                sort_column: sortColumn,
                sort_order: sortOrder,
                "filter.certification_name": filters.certificationName,
                "filter.provider": filters.provider,
                "filter.cost.from": filters.costFrom ? String(filters.costFrom) : 0,
                "filter.cost.to": filters.costTo ? String(filters.costTo) : 0,
                "filter.status": filters.status
            };

            const response = await fetchCertificationDetails(params);
            if (response.status === "success") {

                if (response.data.certificates === null) {
                    setCertificates([]); 
                    setTotalRecords(0);
                    setNumberOfRecords(0);
                    return; 
                }
                // Process financial_approval to be a string instead of object
                const approvedCertificates = response.data.certificates.filter(
                    cert => cert.initial_ph_approval.String === "Approved"
                );
                const processedCertificates = approvedCertificates.map(cert => ({
                    ...cert,
                    financial_approval: cert.financial_approval.String || "Pending", // Default to "Pending" if empty
                    financial_approval_valid: cert.financial_approval.Valid
                }));
                setCertificates(processedCertificates);
                setTotalRecords(processedCertificates.length);
                setNumberOfRecords(processedCertificates.length); // Update with 
            } else {
                throw new Error(response.message || "Failed to fetch certifications");
            }
        } catch (error) {
            console.error("Error fetching certifications:", error);
        } finally {
            setIsLoading(false);
        }
    };
    // seq - 1.29 - 1.32
    // The component calls useEffect with an empty dependency array to run once on component mount.
    const fetchCertificationCount = async () => {
        try {
            debugger
            const params = { emp_id: empId };
            const statsData = await getCertificationCount(params);
            sets3Link(statsData.s3Link)
        } catch (error) {
            console.error("Error fetching certification count:", error);
        }
    };
    // seq 9.21 - 9.22
    // Function to handle button click and open signed URL
    const handleS3LinkClick = async (s3Link) => {
        try {
            // Call getS3url to get the signed URL
            const signedUrlResponse = await getS3(s3Link);

            // Adjust the property name based on your actual response structure
            const signedUrl = signedUrlResponse?.signedUrl || signedUrlResponse;

            if (signedUrl) {
                // Open the signed URL in a new tab
                window.open(signedUrl, '_blank');
            } else {
                console.error('No signed URL received in response');
            }
        } catch (error) {
            console.error('Error fetching signed S3 URL:', error);
        }
    };

    const handleLoadMore = () => {
        setCurrentnumberofRecords(prev => prev + 1);
    };

    const handleSortChange = (column) => {
        if (sortColumn === column) {
            // Toggle sort order if clicking the same column
            setSortOrder(sortOrder === 1 ? -1 : 1);
        } else {
            // New column, default to descending
            setSortColumn(column);
            setSortOrder(-1);
        }
        // No need to call fetchCertifications here since useEffect will trigger it
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
        fetchCertificationDetails();
    };


    const getSortIcon = (column) => {
        if (sortColumn !== column) {
            return "/Images/sort-icon.svg"; // Default icon when not sorted
        }
        return sortOrder === 1 ? "/Images/Sort-up.svg" : "/Images/sort-icon.svg";
    };

    const areAllFiltersEmpty = () => {
        return (
            filters.certificationName === "" &&
            filters.provider === "" &&
            filters.costFrom === "" &&
            filters.costTo === "" &&
            filters.status === ""
        );
    };

    const handleClearFilters = () => {
        setFilters({
            certificationName: "",
            provider: "",
            costFrom: "",
            costTo: "",
            status: ""
        });
        setFiltersVersion(prev => prev + 1);
        };

    const handleStatusChange = (certificate, status) => {
        if (certificate.financial_approval === "Paid") {
            return;
        }

        if (status === "Paid") {
            setSelectedCertificate(certificate);
            setNewStatus(status);
            setShowConfirmation(true);
        } else {
            updateStatus(certificate, status);
        }
    };

    const updateStatus = async (certificate, status) => {
        setIsLoading(true);
        try {
            const payload = {
                action_type: "finance_approval",
                request_id: certificate.request_id,
                emp_id: certificate.emp_id,
                approval_status: status
            };

            // Simulate API call
            const response = await postapprovaldetails(payload);

            if (response.status === "success") {
                // Update local state only if API call succeeds
                setCertificates(prev => prev.map(cert =>
                    cert.request_id === certificate.request_id
                        ? {
                            ...cert,
                            financial_approval: status,
                            financial_approval_valid: true
                        }
                        : cert
                ));

                // Optional: Show success notification
            } else {
                throw new Error(response.message || "Failed to update status");
            }
        } catch (error) {
            console.error("Error updating status:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleApplyFilters = () => {
        fetchCertifications();
    };

    const confirmStatusChange = () => {
        updateStatus(selectedCertificate, newStatus);
        setShowConfirmation(false);
    };

    const handleShowMore = () => {
        fetchCertificationDetails();
    };

    return (
        <div className="body-bg">
            <div className="container-fluid mt-6">
                {/* Header Section with Search and Filter */}

                <div className="row justify-content-center">
                    <div className="col-md-12 d-flex align-items-center">
                        <BreadCrumbs data={breadCrumnData} />
                    </div>
                    <div className="col-md-12 d-flex justify-content-between align-items-center mb-4">
                        <h4 className='font-20'>Manage Certification Payments</h4>
                        <div className="d-flex align-items-center">
                            <div className="input-group flex-nowrap search-group me-3">
                                <input
                                    type="search"
                                    className="form-control search-align"
                                    placeholder="Search"
                                    value={searchTerm}
                                    onChange={handleSearch}
                                />
                                <button className="input-group-text btn btn-search-custom" id="addon-wrapping">
                                    <img src="/Images/search-icon.svg" alt="search-icon" />
                                </button>
                            </div>

                            {/* Filter Section */}
                            <div className="dropdown"  >
                                <button
                                    className="advanced-filter-button me2 medium-text"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <img src="/Images/filter-icon.svg" alt="Filter-icon" className="me-2" />
                                    Filter
                                </button>
                                <div className="dropdown-menu px-4 py-4 advanced-filter-panel shadow session-filter mt-5" aria-labelledby="dropdownMenuButton1">
                                    <div className="row">
                                        <div className="col-md-12 mb-4">
                                            <span className="font-16 semibold-text advanced-filter-title">Advanced Filter</span>
                                            <button type="button" className="btn-close float-end close-filter" data-bs-dismiss="advanced-filter" aria-label="Close"></button>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label hive-form-label" htmlFor='certificateName'>Certification Name</label>
                                            <select
                                                className="form-select hive-form-select"
                                                name="certificationName"
                                                value={filters.certificationName}
                                                id="certificateName"
                                                onChange={(e) => setFilters({ ...filters, certificationName: e.target.value })}
                                            >
                                                <option value="">All</option>
                                                {Array.from(new Set(certificates.map(c => c.certificate_name))).map(name => (
                                                    <option key={name} value={name}>{name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label hive-form-label">Provider</label>
                                            <select
                                                className="form-select hive-form-select"
                                                name="provider"
                                                value={filters.provider}
                                                onChange={(e) => setFilters({ ...filters, provider: e.target.value })}
                                            >
                                                <option value="">All</option>
                                                {Array.from(new Set(certificates.map(c => c.provider))).map(provider => (
                                                    <option key={provider} value={provider}>{provider}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <span className="font-14 semibold-text filter-title">Certification Cost</span>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label hive-form-label">From</label>
                                            <input
                                                type="number"
                                                className="form-control hive-form-control"
                                                placeholder="From"
                                                name="costFrom"
                                                value={filters.costFrom}
                                                onChange={(e) => setFilters({ ...filters, costFrom: e.target.value })}
                                            />
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="ToDate">To</label>
                                            <input
                                                type="number"
                                                className="form-control hive-form-control"
                                                placeholder="To"
                                                name="costTo"
                                                value={filters.costTo}
                                                onChange={(e) => setFilters({ ...filters, costTo: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label hive-form-label">Status</label>
                                        <select
                                            className="form-select hive-form-select"
                                            name="status"
                                            value={filters.status}
                                            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
                                        >
                                            <option value="">All</option>
                                            <option value="Pending">Pending</option>
                                            <option value="In Progress">In Progress</option>
                                            <option value="Paid">Paid</option>
                                        </select>
                                    </div>
                                    <div className="col-md-12 my-3 d-flex justify-content-end">
                                        <button className="btn hive-btn-secondary me-3" onClick={handleClearFilters}>
                                            Clear
                                        </button>
                                        <button className="btn hive-btn-primary" onClick={handleApplyFilters}  disabled={areAllFiltersEmpty()}>
                                            Apply
                                        </button>
                                    </div>
                                </div>

                            </div>
                            <div>
                                <button class="btn hive-btn-outline more-indicator-1 float-left cursor-pointer ms-2"
                                    onClick={() => handleS3LinkClick(s3Link)}>
                                    <img src="/Images/manual.svg" class="me-2" alt="import-icon" />
                                </button>
                                <div class="dropdown-items-1 border border-light mt-2 bg-white rounded-3 p-2 shadow">
                                    <div class="d-flex flex-wrap gap-2">
                                        <span class="practices-badge px-2 py-1 rounded-2">Click here to download the user manual</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Certificates Table */}
                <div className="row justify-content-center mt-3">
                    <table className="table bg-white hive-grid mb-3 table-borderless approval-table">
                        <thead className="hive-table-head">
                            <tr>
                                <th onClick={() => handleSortChange("req_id")}
                                    className={`bold-text font-12 ${sortColumn === "req_id" ? 'sorted' : ''}`}
                                >
                                    Request ID
                                    <span className="ps-2">
                                        <img
                                            src={getSortIcon("req_id")}
                                            alt="Sort"
                                            className={`hive-table-sort ${sortColumn === "req_id" ? "active-sort" : ""}`}
                                        />
                                    </span>
                                </th>
                                <th onClick={() => handleSortChange("emp_id")}
                                    className={`bold-text font-12 ${sortColumn === "emp_id" ? 'sorted' : ''}`}
                                >
                                    Employee ID
                                    <span className="ps-2">
                                        <img
                                            src={getSortIcon("emp_id")}
                                            alt="Sort"
                                            className={`hive-table-sort ${sortColumn === "emp_id" ? "active-sort" : ""}`}
                                        />
                                    </span>
                                </th>
                                <th onClick={() => handleSortChange("emp_name")}
                                    className={`bold-text font-12 ${sortColumn === "emp_name" ? 'sorted' : ''}`}
                                >
                                    Employee Name
                                    <span className="ps-2">
                                        <img
                                            src={getSortIcon("emp_name")}
                                            alt="Sort"
                                            className={`hive-table-sort ${sortColumn === "emp_name" ? "active-sort" : ""}`}
                                        />
                                    </span>
                                </th>
                                <th onClick={() => handleSortChange("certificate_name")}
                                    className={`bold-text font-12 ${sortColumn === "certificate_name" ? 'sorted' : ''}`}
                                >
                                    Certification Name
                                    <span className="ps-2">
                                        <img
                                            src={getSortIcon("certificate_name")}
                                            alt="Sort"
                                            className={`hive-table-sort ${sortColumn === "certificate_name" ? "active-sort" : ""}`}
                                        />
                                    </span>
                                </th>
                                <th onClick={() => handleSortChange("provider")}
                                    className={`bold-text font-12 ${sortColumn === "provider" ? 'sorted' : ''}`}
                                >
                                    Provider
                                    <span className="ps-2">
                                        <img
                                            src={getSortIcon("provider")}
                                            alt="Sort"
                                            className={`hive-table-sort ${sortColumn === "provider" ? "active-sort" : ""}`}
                                        />
                                    </span>
                                </th>
                                <th onClick={() => handleSortChange("cost")}
                                    className={`bold-text font-12 text-end ${sortColumn === "cost" ? 'sorted' : ''}`}
                                >
                                    Certification Cost
                                    <span className="ps-2">
                                        <img
                                            src={getSortIcon("cost")}
                                            alt="Sort"
                                            className={`hive-table-sort ${sortColumn === "cost" ? "active-sort" : ""}`}
                                        />
                                    </span>
                                </th>
                                <th className="bold-text font-12 text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {certificates
                                .filter(cert => cert.initial_ph_approval.String === "Approved")
                                .map(cert => (
                                    <tr key={cert.req_id} className="hive-table-data regular-text">
                                        <td>
                                            <span className="text-primary cursor-pointer hover-underline">
                                                {cert.req_id}
                                            </span>
                                        </td>
                                        <td>{cert.user_id}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <img
                                                    src={cert.profile_img_url.String || ""}
                                                    alt="profile-img"
                                                    className="table-image"
                                                />
                                                <div className="ms-2">
                                                    <p className="text-dark mb-0">{cert.emp_name || "Unknown"}</p>
                                                    <p className="grey-text mb-0 font-11">{cert.role}</p>


                                                </div>
                                            </div>
                                        </td>
                                        <td>{cert.certificate_name} {cert.client_dependency && cert.client_dependency.Bool && (
                                            <span className="client-badge ms-2">Client</span>
                                        )}</td>
                                        <td>{cert.provider}</td>
                                        <td className='text-end'>{cert.certification_cost || "N/A"}</td>
                                        <td className="text-center">
                                            <div className="dropdown payment-status-dropdown">
                                                <button
                                                    className={`btn dropdown-btn ${cert.financial_approval.toLowerCase().trim().replace(/\s+/g, '')} border-0 font-12 medium-text shadow-none`}
                                                    type="button"
                                                    id={`dropdownMenuButton1-${cert.request_id}`}
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                    disabled={cert.financial_approval === "Paid"}
                                                >
                                                    {cert.financial_approval}
                                                    <img
                                                        className="ms-2"
                                                        src="/Images/dropdown-arrow.svg"
                                                        alt="dropdown-arrow"
                                                    />
                                                </button>
                                                <ul
                                                    className="dropdown-menu"
                                                    aria-labelledby={`dropdownMenuButton-${cert.request_id}`}
                                                >
                                                    <li>
                                                        <a
                                                            className="dropdown-item font-12 medium-text"
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleStatusChange(cert, "Pending");
                                                            }}
                                                        >
                                                            Pending
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            className="dropdown-item font-12 medium-text"
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleStatusChange(cert, "In Progress");
                                                            }}
                                                        >
                                                            In Progress
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            className="dropdown-item font-12 medium-text"
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleStatusChange(cert, "Paid");
                                                            }}
                                                        >
                                                            Paid
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    <p className="font-12 pagination">
                        Showing<span className="bold-text mx-1">{numberOfRecords}</span> of
                        <span className="bold-text mx-1">{totalRecords}</span> Records
                    </p>
                    {showLoadMore && (
                        <div className="text-center">
                            <button className="btn show-more-btn" onClick={handleLoadMore}>Show More</button>
                        </div>
                    )}
                </div>

                {showConfirmation && (
                    <CertificateConfirmationPopup
                        onClose={() => setShowConfirmation(false)}
                        onConfirm={confirmStatusChange}
                    />
                )}

            </div>
        </div>

    );
};

export default FinanceManagement;